import { useI18n } from "../i18n";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { FrequencyDial } from "../components/FrequencyDial";
import { Oscilloscope } from "../components/Oscilloscope";
import { WordDisplay } from "../components/WordDisplay";
import { Controls } from "../components/Controls";
import { QuestionBar } from "../components/QuestionBar";
import { GhostHeader } from "../components/GhostHeader";
import { SessionTabs } from "../components/SessionTabs";
import { useGhostAudio } from "../hooks/useGhostAudio";
import { useSessionControl } from "../hooks/useSessionControl";

export default function GhostBox() {
  const { t, lang, meta } = useI18n();
  const { user, refresh } = useAuth();
  const [speed, setSpeed] = useState(90);
  const [volume, setVolume] = useState(0.5);
  const [voice, setVoice] = useState(true);
  const audio = useGhostAudio({ speed, volume, voice, lang, tts: meta.tts });
  const ctl = useSessionControl({ user, refresh, audio });
  const wordCount = audio.log.filter((e) => e.type !== "q").length;

  return (
    <div className="ghost-root" data-testid="ghost-box-app">
      <div className="scanlines" />
      <div className="max-w-4xl mx-auto px-4 py-8 flex flex-col gap-5 relative z-10">
        <GhostHeader active={audio.active} elapsed={ctl.elapsed} maxSeconds={ctl.maxSeconds} user={user} wordCount={wordCount}
          onBack={() => !audio.active && ctl.navigate("/")} />
        <FrequencyDial freq={audio.freq} active={audio.active} stations={ctl.stations} tuned={audio.tuned} />
        <div className="panel px-5 py-3"><Oscilloscope engineRef={audio.engine} active={audio.active} /></div>
        <WordDisplay word={audio.word} active={audio.active} />
        <QuestionBar active={audio.active} onAsk={audio.ask} />
        <Controls active={audio.active} onToggle={audio.active ? ctl.stop : ctl.start} speed={speed} setSpeed={setSpeed}
          volume={volume} setVolume={setVolume} voice={voice} setVoice={setVoice} />
        <SessionTabs tab={ctl.tab} setTab={ctl.setTab} log={audio.log} prediction={ctl.prediction}
          sessions={ctl.archive.sessions} onDelete={ctl.archive.remove} />
        <p className="text-center text-xs text-subtle font-mono pb-4">{t("sessionFooter")}</p>
      </div>
    </div>
  );
}
